<template>
  <div class="helpContract">
    <help-header />
    <v-divider class="helpContract_divider" />
    <section class="helpContract_content">
      <div
        v-for="(item, index) in topics"
        :key="index"
        v-ripple
        class="helpContract_item"
        @click="
          navigateTo({
            name: 'help-cat-list',
            params: {
              id: $route.params.id,
              topic: item.id,
            },
          })
        "
      >
        <div class="helpContract-collapse">
          <router-link
            :to="{
              name: 'help-cat-list',
              params: {
                id: $route.params.id,
                topic: item.id,
              },
            }"
          >
            <h5>{{ item.title }}</h5>
          </router-link>
          <v-icon class="helpContract-collapse--icon" size="22">
            mdi-chevron-right
          </v-icon>
        </div>
        <span v-if="item.desc" class="helpContract_item-desc">{{
          item.desc
        }}</span>
        <section
          v-if="item.details && item.details.length"
          class="helpContract_item-details"
        >
          <h5 v-for="(detail, detailIndex) in item.details" :key="detailIndex">
            {{ detail.title }}
          </h5>
        </section>
      </div>
    </section>

    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HelpHeader from '../HelpHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'HelpContract',
  components: {
    HelpHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogMessageText: '',
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
    }),
    currentCategory() {
      return this.helpCategories.find(
        (item) => item.id === this.$route.params.id
      );
    },
    topics() {
      return (this.currentCategory || {}).sub_topic || [];
    },
  },
  watch: {
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
  },
  mounted() {
    if (this.$route.query.dl === 1) {
      this.displayDeleteMessage();
    }
  },
  methods: {
    navigateTo(route) {
      this.routerPush(route);
    },
    displayDeleteMessage() {
      this.dialogMessageText = 'グループを削除しました。';
      this.$router.replace({ query: null });
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.helpContract {
  &_divider {
    margin-top: 15px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }

  &_content {
    padding: 0;
    max-height: 510px;
    overflow-y: auto;
  }

  &_item {
    padding: 15px 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #eee;

    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
    &-details {
      margin-top: 10px;
      h5 {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
    }
  }
  &-collapse {
    cursor: pointer;
    display: inline-block;
    h5 {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &--icon {
      margin-left: 5px;
      color: #c1c1c1 !important;
    }
  }
}
</style>
